(function () {
'use strict';

angular
    .module('adminRoutes', [
        'adminControllers',
        'adminCACMRoutes',
        'adminODDRoutes',
        'adminReferenceDataRoutes',
        'adminTravelRoutes',
    ])
    .config(routeur);

routeur.$inject = ['$stateProvider'];

function routeur($stateProvider) {

    $stateProvider
            .state('admin', {
                url: '/Admin',
                controller: 'AdminController',
                templateUrl: require('./admin.tpl.html')
            });
    }
})();